import { jsxs as i, jsx as n } from "react/jsx-runtime";
import { Icon as r } from "../Icon/Icon.js";
import { TextStyle as a } from "../TextStyle/TextStyle.js";
import { UnstyledBlockContent as t } from "../UnstyledBlockContent/UnstyledBlockContent.js";
const m = "InclusionDrawerSection-module_inclusion-title__2SeQ8",
  u = "InclusionDrawerSection-module_content__uSeoQ",
  e = {
    inclusionTitle: m,
    content: u
  },
  _ = _ref => {
    let {
      icon: l,
      title: c,
      description: s,
      tokens: o
    } = _ref;
    return /* @__PURE__ */i("div", {
      className: e.blockDetail,
      children: [/* @__PURE__ */i("div", {
        className: e.inclusionTitle,
        children: [/* @__PURE__ */n(r, {
          name: l,
          size: "2x",
          wrapperClassName: e.icon,
          padding: !1
        }), /* @__PURE__ */n(t, {
          value: c,
          tokens: o
        })]
      }), /* @__PURE__ */n(a, {
        fontSize: "inherit",
        className: e.content,
        children: /* @__PURE__ */n(t, {
          value: s,
          tokens: o
        })
      })]
    });
  };
export { _ as InclusionDrawerSection };